import React from "react";
import cn from "classnames";
import s from "./DefaultMarketStoryHeader.module.scss";
import { useStoryContext } from "@widgets/components/__Insights/InsightStoryList/context/StoryContext";
import { FaChevronLeft } from "react-icons/fa";
import IllioLogo from "@widgets/assets/IllioLogo";
import { PoweredByLogo } from "@widgets/assets/PoweredByLogo";

interface IOwnProps {
  watchlistName?: string;
  title?: string;
  onBackPress?: () => void;
}

export const DefaultMarketStoryHeader = React.memo((props: IOwnProps) => {
  const { currentInsight } = useStoryContext();

  const title = props.title || (currentInsight?.data as any)?.title;
  const watchlistName =
    props.watchlistName || (currentInsight?.data as any)?.watchlistName;
  const onBackPress = props?.onBackPress;

  const renderTitle = (hideMobile?: boolean) => {
    return (
      <div
        className={cn(
          s.detailsSurround,
          hideMobile ? s.hideMobile : s.hideDesktop
        )}
      >
        <div data-testid={`market-insights-title`} className={s.title}>
          {title}
        </div>
        <div data-testid={`market-insights-name`}>{watchlistName}</div>
      </div>
    );
  };

  return (
    <div className={s.wrapper}>
      <div className={cn(s.surround)}>
        <div className={cn(s.backArea)}>
          <div
            className={cn(s.horizontal, onBackPress && s.clickable)}
            {...(onBackPress
              ? { onClick: onBackPress, tabIndex: 0, role: "button" }
              : {})}
          >
            {onBackPress && (
              <div className={cn(s.backArrow)}>
                <BackArrow />
              </div>
            )}
            Insights by illio
          </div>
        </div>
        {renderTitle(true)}
        <div className={cn(s.logoSurround)}>
          <PoweredByLogo />
        </div>
        <hr className={cn(s.divider)} />
      </div>
      {renderTitle(false)}
      {/*<pre style={{fontSize: 12}}>{JSON.stringify({currentInsight}, null, 2)}</pre>*/}
    </div>
  );
});

const BackArrow = () => {
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.01 1.65207L1.19592 10.466M1.19592 10.466L10.01 19.2799M1.19592 10.466L22.5 10.466"
        stroke="currentColor"
        stroke-width="2.37976"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
